import { render, staticRenderFns } from "./ClientConfigPage.vue?vue&type=template&id=9ed2c088"
import script from "./ClientConfigPage.vue?vue&type=script&lang=js"
export * from "./ClientConfigPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports